import {ColorTheme} from "../../../themes/theme.model";

export class CurrentLandlordModel {
  uuid!: string;
  companyName!: string;
  companyLogo?: string;
  landlordStatus!: string;
  theme!: ColorTheme;
  code!: string;
}

export enum OfferingConfigCode {
  APP_FORM_QR_CODE_DESTINATION = "APP_FORM_QR_CODE_DESTINATION",
  SURVEY_QR_CODE_DESTINATION = "SURVEY_QR_CODE_DESTINATION"
}

export interface QrCodeDestination {
  formCode: string;
  mode: OfferingConfigCode;
  destination?: string | null;
}

export interface ApplicationFormRedirectRequest {
  enabled: boolean;
  url: string | null;
}
